
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('customer_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/sale/customer-create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onShow()"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</button>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('no') }}</th>
                                <th>{{ $t('barcode') }}</th>
                                <th>{{ $t('khmer_name') }}</th>
                                <th>{{ $t('latin_name') }}</th>
                                <th>{{ $t('customer_type')}}</th>
                                <th>{{ $t('phone') }}</th>
                                <th>{{ $t('email') }}</th>
                                <th>ID Card OR VAT-TIN</th>
                                <th>{{ $t('address') }}</th>
                                <th style="width: 22px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'customer_edit', params:{id:ret.Id}}">{{ret.Code}}</router-link></td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.NameEng}}</td>
                                <td>{{ret.CustomerTypeName}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{ret.Email}}</td>
                                <td>{{ret.VatTin}}</td>
                                <td>{{ret.Address}}</td>
                                <td>
                                    <div class="cell-action">
                                        <button type="button" class="btn btn-danger btn-sm btn-xs" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div> 
            </div>      
        </div>
        <b-modal no-close-on-backdrop centered size="lg"
            modal-class="x-modal"
            title="IMPORT CUSTOMER"
            ref="innerform"
            footer-class="justify-content-between">
            <div class="vl-parent" ref="ldCond">
                <div class="row mb-2">
                    <div class="col-sm-4">
                        <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                        <button type="button" class="btn btn-success btn-sm" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-table :fields="fields" :items="imports" ref="table"
                            selectable
                            @row-selected="onRowSelected"
                            selected-variant="primary"
                            class="table-sm no-bor">
                            <template #cell(index)="data">
                                {{ data.index + 1 }}
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div>
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="$refs.table.selectAllRows()" :disabled="imports.length==0"><i class="fa fa-check-square" aria-hidden="true"></i> SELECT ALL</button>&nbsp;
                    <button type="button" class="btn btn-outline-danger btn-sm" @click="$refs.table.clearSelected()" :disabled="imports.length==0"><i class="fa fa-ban" aria-hidden="true"></i> UNSELECT ALL</button>
                </div>
                <div><button type="button" class="btn btn-outline-success btn-sm" :disabled="selectedRows.length==0" @click="onCopy"><i class="fa fa-copyright" aria-hidden="true"></i> COPY</button></div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Customer from '../../shared/models/Customer';
export default {
    data(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                CompanyId: this.$store.state.company.Id
            },
            records:[],
            imports: [],
            selectedRows: [],
            viewType: 0,
            header: { 'Content-Type': 'multipart/form-data' },
            fields: [
                'index',
                { key: 'Name' },
                { key: 'NameEng' },
                { key: 'InvoiceType' },
                { key: 'Phone' },
                { key: 'VatTin', label: 'IdCard OR VAT-TIN' }
            ]
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            Customer.toList(this.query).then(res => {
                this.records = res.Data;
                this.query.Total = res.Total;
            }).finally(() => loading.hide());
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        viewTypeChange(n){
            this.viewType = n;
        },
        onDelete(id){
            this.$swal.fire({
                title: 'សារបញ្ជាក់',
                text: "តើលោកអ្នកពិតជាចង់លុបទិន្នន័យម៉ែនទេ?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'បោះបង់',
                confirmButtonText: 'យល់ព្រម'
                }).then((result) => {
                if (result.value) {
                    Customer.delete({ Id: id }).then(() => {
                        this.toList();
                        this.$swal.fire('សាបញ្ជាក់', 'ទិន្នន័យរបស់លោកអ្នកត្រូវបានលុបដោយជោកជ័យ.', 'success');
                    });
                }
            });
        },
        onShow(){
            this.$refs.innerform.show();
        },
        onUpload(){
            var formData = new FormData();
            formData.append('File', this.$refs.file.files[0]);
            let loading = this.$loading.show();
            this.$api().post('customer/upload', formData, this.header).then(res => {
                if(this.$isValid(res)){
                    this.imports = res.data.Json.Customers;
                    this.$refs.file.value = null;
                }
            }).finally(() => { loading.hide(); });
        },
        onRowSelected(items){
            this.selectedRows = items;
        },
        onCopy(){
            let loading = this.$loading.show({
                container: this.$refs.ldCond
            });
            for (let i = 0; i < this.selectedRows.length; i++) {
                let item = this.selectedRows[i];
                item.CompanyId = this.$store.state.company.Id;
                item.ClientId = this.$store.state.company.ClientId;
            }
            this.$api().post('customer/import', this.selectedRows).then(res => {
                if(this.$isValid(res)){
                    this.selectedRows = [];
                    this.imports = [];
                    this.$refs.innerform.hide();
                    this.toList();
                }
            }).finally(() => { loading.hide(); });
        }
    }
}
</script>